module.exports = __webpack_public_path__ + "static/media/onboarding-what-to-expect-line-vertical.7055f823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-what-to-expect-line-vertical.svg
// module id = 691
// module chunks = 0